import { registerCapability } from '../../platform/capability-registry';
import { StorageBlock } from './StorageBlock';
import { STORAGE_ACTION_KEY_LIST, STORAGE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveStoragePaths } from './resolvePaths';
import type { StorageBlockOptions } from './types';

registerCapability<StorageBlockOptions>({
  key: 'storage',
  fields: [...STORAGE_FIELD_KEY_LIST],
  actions: [...STORAGE_ACTION_KEY_LIST],
  component: StorageBlock,
  defaultPaths: (prefix) => resolveStoragePaths(prefix),
  resolvePaths: (prefix, options) => resolveStoragePaths(prefix, options),
});
